import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Linkedin, Youtube } from 'lucide-react';
import { Container } from '../ui/Container';
export function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const navigation = {
    product: [{
      name: 'Features',
      href: '/features'
    }, {
      name: 'Pricing',
      href: '/pricing'
    }],
    resources: [{
      name: 'Guides',
      href: '/resources'
    }],
    company: [{
      name: 'About',
      href: '/about'
    }, {
      name: 'Contact',
      href: '/contact'
    }],
    legal: [{
      name: 'Privacy',
      href: '/privacy'
    }, {
      name: 'Terms',
      href: '/terms'
    }, {
      name: 'EULA',
      href: '/eula'
    }, {
      name: 'Security',
      href: '/security'
    }],
    social: [{
      name: 'Twitter',
      href: '#',
      icon: (props: any) => <Twitter {...props} data-id="element-91" />
    }, {
      name: 'LinkedIn',
      href: '#',
      icon: (props: any) => <Linkedin {...props} data-id="element-92" />
    }, {
      name: 'YouTube',
      href: '#',
      icon: (props: any) => <Youtube {...props} data-id="element-93" />
    }]
  };
  return <footer className="bg-white border-t border-gray-200" aria-labelledby="footer-heading" data-id="element-94">
      <h2 id="footer-heading" className="sr-only" data-id="element-95">
        Footer
      </h2>
      <Container className="py-12 lg:py-16" data-id="element-96">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8" data-id="element-97">
          <div className="space-y-8" data-id="element-98">
            <Link to="/" onClick={scrollToTop} className="flex items-center space-x-2" data-id="element-99">
              <img src="https://cdn.magicpatterns.com/uploads/dPM9KUkaUrxRQPXFhc49CA/flowsense.png" alt="Flowsense" className="h-8 w-8" data-id="element-100" />
              <span className="text-xl font-bold text-gray-900" data-id="element-101">Flowsense</span>
            </Link>
            <p className="text-sm leading-6 text-gray-600 max-w-xs" data-id="element-102">
              Turn your Klaviyo flows into revenue machines with AI-powered
              insights and actionable recommendations.
            </p>
            <div className="flex space-x-6" data-id="element-103">
              {navigation.social.map(item => <a key={item.name} href={item.href} className="text-gray-400 hover:text-gray-500" data-id="element-104">
                  <span className="sr-only" data-id="element-105">{item.name}</span>
                  <item.icon className="h-6 w-6" aria-hidden="true" data-id="element-106" />
                </a>)}
            </div>
          </div>
          <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0" data-id="element-107">
            <div className="md:grid md:grid-cols-2 md:gap-8" data-id="element-108">
              <div data-id="element-109">
                <h3 className="text-sm font-semibold leading-6 text-gray-900" data-id="element-110">
                  Product
                </h3>
                <ul role="list" className="mt-6 space-y-4" data-id="element-111">
                  {navigation.product.map(item => <li key={item.name} data-id="element-112">
                      <Link to={item.href} onClick={scrollToTop} className="text-sm leading-6 text-gray-600 hover:text-gray-900" data-id="element-113">
                        {item.name}
                      </Link>
                    </li>)}
                </ul>
              </div>
              <div className="mt-10 md:mt-0" data-id="element-114">
                <h3 className="text-sm font-semibold leading-6 text-gray-900" data-id="element-115">
                  Resources
                </h3>
                <ul role="list" className="mt-6 space-y-4" data-id="element-116">
                  {navigation.resources.map(item => <li key={item.name} data-id="element-117">
                      <Link to={item.href} onClick={scrollToTop} className="text-sm leading-6 text-gray-600 hover:text-gray-900" data-id="element-118">
                        {item.name}
                      </Link>
                    </li>)}
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8" data-id="element-119">
              <div data-id="element-120">
                <h3 className="text-sm font-semibold leading-6 text-gray-900" data-id="element-121">
                  Company
                </h3>
                <ul role="list" className="mt-6 space-y-4" data-id="element-122">
                  {navigation.company.map(item => <li key={item.name} data-id="element-123">
                      <Link to={item.href} onClick={scrollToTop} className="text-sm leading-6 text-gray-600 hover:text-gray-900" data-id="element-124">
                        {item.name}
                      </Link>
                    </li>)}
                </ul>
              </div>
              <div className="mt-10 md:mt-0" data-id="element-125">
                <h3 className="text-sm font-semibold leading-6 text-gray-900" data-id="element-126">
                  Legal
                </h3>
                <ul role="list" className="mt-6 space-y-4" data-id="element-127">
                  {navigation.legal.map(item => <li key={item.name} data-id="element-128">
                      <Link to={item.href} onClick={scrollToTop} className="text-sm leading-6 text-gray-600 hover:text-gray-900" data-id="element-129">
                        {item.name}
                      </Link>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 border-t border-gray-900/10 pt-8 sm:mt-20 lg:mt-24" data-id="element-130">
          <p className="text-xs leading-5 text-gray-500" data-id="element-131">
            &copy; 2025 Flowsense by Acciom Limited. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>;
}